import { create } from 'zustand';

/**
 * Форма «Сообщить о проблеме» живёт НАД маршрутами: кнопок в шапке две
 * (компьютер и телефон), окно одно, и переход по панели набранный текст не теряет.
 */
interface SupportFormState {
  open: boolean;
  text: string;
  setOpen: (open: boolean) => void;
  setText: (text: string) => void;
}

export const useSupportForm = create<SupportFormState>()((set) => ({
  open: false,
  text: '',
  setOpen: (open) => set({ open }),
  setText: (text) => set({ text }),
}));
